import compose from 'recompose/compose';
import { connect } from 'react-redux';
import _get from 'lodash/get';
import { fetchCatalog as commonsFetchCatalog } from 'store/commons/actions';
import {
  downloadFiles,
  getStatement,
  updateCustomerStatus,
} from 'store/customers/actions';
import CustomerInformationDetail from './CustomerInformation';

export default compose(
  connect(
    (state) => ({
      data: _get(state, 'customers.customerDetail.data', {}),
      responseDialog: _get(state, 'customers.responseDialog', {}),
      customerStatus: _get(state, 'commons.customerStatus.list', {}),
    }),
    { downloadFiles, getStatement, updateCustomerStatus, commonsFetchCatalog }
  )
)(CustomerInformationDetail);
